import Swiper from 'swiper';
import 'swiper/css';
import { Navigation } from 'swiper/modules';

/**
 * Клас для ініціалізації Swiper
 * 
 * @package AGDS
 * @category Modules
 * @module Swiper
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class SwiperSlider {

	/**
	 * Конструктор
	 *
	 * @param {Object} options
	 */
	constructor(options = {}) {
		this.windowWidth = options.windowWidth
		this.swiperEls = options.swiperEls

		this.defaultOptions = {
			speed: 800,
			breakpoints: {
				992: { slidesPerView: 3, spaceBetween: 30 },
				768: { slidesPerView: 2.2, spaceBetween: 20 },
				320: { slidesPerView: 1.2, spaceBetween: 20 }
			},
		}
	}

	/**
	 * Ініціалізація
	 */
	init() {
		if (typeof Swiper === 'undefined') {
			console.error('Swiper is not defined')
			return
		}

		// Слайдери
		this.valuesSliderInit()
		this.teamSliderInit()
		this.reviewsSliderInit()
		this.productsSliderInit()
	}

	/**
	 * Створює слайдер і зливає (merges) налаштування
	 * @param {HTMLElement|string} elementOrSelector - DOM-елемент або CSS селектор
	 * @param {Object} customOptions - Унікальні параметри для цього слайдера
	 * @returns {Array} Масив інстансів Swiper
	 */
	createSlider(elementOrSelector, customOptions = {}) {
		const elements = typeof elementOrSelector === 'string'
			? document.querySelectorAll(elementOrSelector)
			: [elementOrSelector]

		if (!elements || elements.length === 0) return

		// Зливаємо дефолтні опції з кастомними.
		const finalOptions = {
			...this.defaultOptions,
			...customOptions,
			breakpoints: {
				...this.defaultOptions.breakpoints,
				...(customOptions.breakpoints || {})
			}
		};

		const instances = []

		elements.forEach(el => {
			if (el.classList.contains('swiper-initialized')) {
				return
			}

			const swiper = new Swiper(el, finalOptions)

			// Класи
			swiper.on('init', (s) => {
				if (s.params.centeredSlides) {
					s.el.classList.add('swiper-centered-slides')
				}
				if (s.params.loop) {
					s.el.classList.add('swiper-is-loop')
				}
			});

			// Якщо Swiper вже ініціалізувався (іноді буває миттєво), 
			// викликаємо init вручну один раз для класів
			if (swiper.initialized) {
				swiper.emit('init')
			}

			instances.push(swiper)
		})

		return instances;
	}

	/**
	 * Слайдер Values
	 */
	valuesSliderInit() {
		this.createSlider('.values-slider', {
			modules: [Navigation],
			navigation: {
				nextEl: ".slider-button--next",
				prevEl: ".slider-button--prev",
			},
		})
	}

	/**
	 * Слайдер Reviews
	 */
	reviewsSliderInit() {
		this.createSlider('.reviews-slider', {
			modules: [Navigation],
			centeredSlides: true,
			// loop: true,
			navigation: {
				nextEl: ".slider-button--next",
				prevEl: ".slider-button--prev",
			},
			breakpoints: {
				992: { slidesPerView: 1.8, spaceBetween: 150 },
				768: { slidesPerView: 1.5, spaceBetween: 20 },
				320: { slidesPerView: 1, spaceBetween: 0 }
			},
			on: {
				init: (swiper) => {
					this.updateCounter(swiper)
				},
				slideChange: (swiper) => {
					this.updateCounter(swiper)
				}
			}
		})
	}

	/**
	 * Слайдер Team
	 */
	teamSliderInit() {
		if (this.windowWidth >= 768) return
		this.createSlider('.team-slider')
	}

	/**
	 * Слайдер Team
	 */
	productsSliderInit() {
		if (this.windowWidth >= 768) return
		this.createSlider('.products-slider', {
			centeredSlides: true,
			loop: true,
			breakpoints: {
				320: { slidesPerView: 1.5, spaceBetween: 20 }
			}
		})
	}

	/**
	 * Оновлює значення слайдера
	 */
	updateCounter(swiper) {
		const counterEl = swiper.el.querySelector('.slider-counter')
		if (!counterEl) return

		const currentBox = counterEl.querySelector('.current')
		const totalBox = counterEl.querySelector('.total')
		if (!currentBox || !totalBox) return

		const current = swiper.realIndex + 1;
		const totalCount = swiper.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate')).length

		currentBox.textContent = current.toString().padStart(2, '0');
		totalBox.textContent = totalCount.toString().padStart(2, '0');
	}
}
